import React, { FC } from 'react';

import { ReactComponent as Tail } from './tail-spin.svg';

import css from './Spinner.module.css';

const Spinner: FC = () => {
  return <Tail className={css.Arrow} />;
};

export default Spinner;
